import * as React from "react";
import { Input } from "components/bootstrap";
import useProductName from "brand-customization/useProductName";
const ThrottlingCheckbox = ({ id, defaultChecked, onChange }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id,
      type: "checkbox",
      value: "enable-throttling",
      defaultChecked,
      onChange,
      label: "Enable Throttling",
      help: `If enabled, no new messages will be read from this input until the ${productName} server catches up with its message load. This is typically useful for inputs reading from files or message queue systems like AMQP or Kafka. If you regularly poll an external system, e.g. via HTTP, you normally want to leave this disabled.`
    }
  );
};
export default ThrottlingCheckbox;
